import {Component, inject, OnInit, signal} from '@angular/core';
import {MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButton} from "@angular/material/button";
import {MatInput} from "@angular/material/input";
import {lastValueFrom} from "rxjs";
import {CreateThirdPlaceMatchDto, ThirdPlaceMatchEndpointService} from "@api";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatOption, MatSelect} from "@angular/material/select";

@Component({
    selector: 'app-third-place-dialog',
    standalone: true,
    imports: [
        MatDialogContent,
        MatDialogTitle,
        MatInput,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelect,
        MatOption,
        MatButton,
    ],
    templateUrl: './third-place-dialog.component.html',
    styleUrl: './third-place-dialog.component.scss'
})
export class ThirdPlaceDialogComponent implements OnInit {
    tournamentId = signal<number | undefined>(undefined);
    thirdPlaceMatchEndpoint = inject(ThirdPlaceMatchEndpointService);
    dialogRef = inject(MatDialogRef);
    form = new FormGroup(
        {
            team1Name: new FormControl<string | null>(null),
            team2Name: new FormControl<string | null>(null),
            team1Won: new FormControl<boolean>(false),
            team1DrinksCollected: new FormControl<boolean>(false),
            team2DrinksCollected: new FormControl<boolean>(false),
            tableName: new FormControl<string | null>(null),
            matchFinished: new FormControl<boolean>(false)
        }
    )

    ngOnInit(): void {
        if (this.tournamentId()) {
            this.thirdPlaceMatchEndpoint.getThirdMatchByTournament(this.tournamentId()!).subscribe({
                next: value => {
                    console.log(value);
                    this.form.controls.tableName.setValue(value.tableName ?? null);
                    this.form.controls.team1Name.setValue(value.team1Name ?? null);
                    this.form.controls.team2Name.setValue(value.team2Name ?? null);
                    this.form.controls.team1Won.setValue(value.team1Won ?? false);
                    this.form.controls.team1DrinksCollected.setValue(value.team1DrinksCollected ?? false);
                    this.form.controls.team2DrinksCollected.setValue(value.team2DrinksCollected ?? false);
                    this.form.controls.matchFinished.setValue(value.matchFinished ?? false);
                }
            });
        }
    }


    async save() {
        if (this.tournamentId()) {
            const dtoToSend: CreateThirdPlaceMatchDto = {
                tournamentId: this.tournamentId()!,
                team1Name: this.form.controls.team1Name.value === null ? undefined : this.form.controls.team1Name.value,
                team2Name: this.form.controls.team2Name.value === null ? undefined : this.form.controls.team2Name.value,
                team1DrinksCollected: this.form.controls.team1DrinksCollected.value === null ? undefined : this.form.controls.team1DrinksCollected.value,
                team2DrinksCollected: this.form.controls.team2DrinksCollected.value === null ? undefined : this.form.controls.team2DrinksCollected.value,
                tableName: this.form.controls.tableName.value === null ? undefined : this.form.controls.tableName.value,
                team1Won: this.form.controls.team1Won.value === null ? undefined : this.form.controls.team1Won.value,
                matchFinished: this.form.controls.matchFinished.value === null ? undefined : this.form.controls.matchFinished.value
            }
            await lastValueFrom(this.thirdPlaceMatchEndpoint.saveThirdPlaceMatch(this.tournamentId()!, dtoToSend))
            this.dialogRef.close();
        }
    }
}
